module.exports = {
    email: 'contact@josdem.io',
    subject: 'Hello and welcome!',
    body: 'This is the body of the email',
};
